import store from '@/store';

window.onunhandledrejection = event => {
  if (event.reason.code === 'API_ERROR') {
    store.dispatch('setSystemErrorAction');
  }
};
